export function truncateName(name: string, maxLength: number, maxWords: number = 2): string {
  const words = name.trim().split(/\s+/)

  if (words.length <= maxWords && name.length <= maxLength) {
    return name
  }

  if (words.length === 0) {
    return ''
  }

  const pickWords = words.slice(0, maxWords)

  if (pickWords.length === 1) {
    return pickWords[0].slice(0, maxLength)
  }

  const firstName = pickWords[0]
  const otherInitials = pickWords
    .slice(1)
    .map((word) => word.charAt(0).toUpperCase())
    .join('.')

  const result = `${firstName} ${otherInitials}`

  if (result.length <= maxLength) {
    return result
  }

  return result.slice(0, maxLength)
}
